import styled from "styled-components";

export const RoutesWrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    height: 100svh;
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
    flex-direction: column-reverse;
  }
`;

export const Content = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  background-color: #000000;
  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    height: 100svh;
    height: 100dvh;
    padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior-y: contain;
    -webkit-overflow-scrolling: touch;
  }
`;

export const Logo = styled.img`
  width: 28%;
`;

export const HeaderBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const BrandStar = styled.img`
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
`;

export const BrandWordmark = styled.img`
  display: block;
  width: clamp(78px, 21vw, 88px);
  height: auto;
  flex: 0 1 auto;
  min-width: 0;
  opacity: 0.96;
`;

export const OpenLinks = styled.div`
  color: #ffffff;
  font-size: 16px;
  align-items: center;
`

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 30;
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: rgba(5, 5, 6, 0.78);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.14);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  padding: 0 12px;
  flex-shrink: 0;

  @media screen and (max-width: 380px) {
    gap: 8px;
    padding: 0 10px;

    ${BrandStar} {
      width: 28px;
      height: 28px;
    }

    ${BrandWordmark} {
      width: 76px;
    }
  }

  @media screen and (max-width: 330px) {
    ${BrandWordmark} {
      display: none;
    }
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`;
export const InstallLink = styled.button`
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.94);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  padding: 8px 0 7px;
  white-space: nowrap;
  flex: 0 0 auto;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  @media screen and (max-width: 380px) {
    font-size: 12.5px;
  }
`;

export const InstallGuideOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(12px, env(safe-area-inset-top)) 18px max(12px, env(safe-area-inset-bottom));
  background: rgba(0, 0, 0, 0.58);
`;

export const InstallGuidePanel = styled.div`
  position: relative;
  width: min(86vw, 276px);
  color: #ffffff;
`;

export const InstallGuideClose = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
`;

export const InstallGuideLogo = styled.div`
  margin: 0 0 3px;
  font-size: clamp(18px, 5.8vw, 23px);
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1;
`;

export const InstallGuideTitle = styled.h2`
  margin: 0 0 7px;
  font-size: clamp(16px, 4.8vw, 19px);
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
`;

export const InstallGuideCard = styled.div`
  padding: 8px 8px 10px;
  border: 1px solid transparent;
  border-radius: 12px;
  background:
    linear-gradient(#171717, #171717) padding-box,
    linear-gradient(135deg, #ff8a22, #e3a3ff 48%, #1688ff) border-box;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.36);
`;

export const InstallGuideImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: clamp(214px, 48vh, 338px);
  margin: 0 auto;
  overflow: hidden;
`;

export const InstallGuideImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const InstallGuideImageFrame = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
`;

export const InstallGuideShareHighlight = styled.span`
  position: absolute;
  top: 13%;
  right: 3.5%;
  width: 9.5%;
  height: 14%;
  border: 2px solid #ff3030;
  border-radius: 4px;
  pointer-events: none;
`;

export const InstallGuidePlaceholder = styled.div`
  display: flex;
  min-height: 150px;
  width: min(100%, 230px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.78);
  text-align: center;

  strong {
    color: #ffffff;
    font-size: 15px;
  }
`;

export const InstallGuideText = styled.p`
  margin: 8px 0 0;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
`;

export const InstallGuideFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-top: 7px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
  line-height: 1.3;
  text-align: center;

  button {
    border: 0;
    padding: 1px 2px;
    background: transparent;
    color: #ffffff;
    font: inherit;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }
`;

export const InstallGuideDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 8px 0 0;
`;

export const InstallGuideDot = styled.button<{ $active: boolean }>`
  width: 7px;
  height: 7px;
  border: 0;
  border-radius: 50%;
  background: ${({ $active }) => ($active ? "#ffffff" : "rgba(255, 255, 255, 0.38)")};
  padding: 0;
  cursor: pointer;
`;

export const InstallGuideActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 8px auto 0;
`;

export const InstallGuideButton = styled.button`
  display: block;
  width: auto;
  min-height: 0;
  margin: 8px auto 0;
  border: 0;
  border-radius: 999px;
  background: #ffffff;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 13px;
  cursor: pointer;

  ${InstallGuideActions} & {
    margin: 0;
  }
`;

export const InstallGuideSecondaryButton = styled.button`
  display: block;
  width: auto;
  min-height: 0;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.42);
  border-radius: 999px;
  background: transparent;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  cursor: pointer;
`;

export const InstallGuideBrowserCard = styled.div`
  padding: 14px 12px 13px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  background: #171717;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.32);
`;
